import CollapsibleContainer from "./collapsibleContainer";

export default CollapsibleContainer;